import React from 'react'
import PropTypes from 'prop-types'
import toast from 'react-hot-toast'
import { Card, Row, Col, CardTitle } from 'reactstrap'

const MenuItem = ({ item, onSelectProduct }) => {
    const { name, vendorName, servingTimes, isService, isAllVariantSoldOut } = item

    const onItemClick = () => {
        if (!isService) {
            toast(
                'Available from\n' + servingTimes.map(time => `${time.days.join(', ')}: ${time.open} - ${time.close}`).join('\n'),
                {
                    duration: 5000,
                    icon: <i className="bx bx-sm bx-time"></i>,
                }
            )
        } else if (isAllVariantSoldOut) {
            toast('All variants are sold out', { duration: 5000, icon: <i className="bx bx-sm bx-error text-danger"></i> })
        } else {
            onSelectProduct(item)
        }
    }

    const _renderPrice = () => {
        if (!item.variants?.length) return null
        const { lowestPrice } = item

        // If have no price variant
        if (lowestPrice === Infinity) {
            return 'Ala carte price'
        }

        return `${item.variants.length > 1 ? 'From ' : ''}$${lowestPrice.toFixed(2)}`
    }

    return (
        <Card className={`menu-item ${!isService || isAllVariantSoldOut ? 'disabled' : ''}`} onClick={() => onItemClick()}>
            <Row noGutters>
                <Col xs="12">
                    <div className="menu-item-content">
                        <div className="menu-item-title">
                            <h5 className={`mb-0 ${isService && isAllVariantSoldOut ? 'text-danger' : ''}`}>
                                {name} {isService && isAllVariantSoldOut ? ' (Sold out)' : ''}
                            </h5>
                            <span className="menu-item-price">{_renderPrice()}</span>
                        </div>
                        <CardTitle className="menu-item-vendor" style={{ color: retrieveVendorColor(vendorName) }}>
                            {vendorName}
                        </CardTitle>
                    </div>
                </Col>
                {/* <Col xs="4">
                  <CardImg src={item.image} alt={item.name} className="menu-item-image" />
                </Col> */}
            </Row>
        </Card>
    )
}

MenuItem.propTypes = {
    key: PropTypes.number,
    item: PropTypes.object,
    quantity: PropTypes.number,
    onSelectProduct: PropTypes.func,
}

export default MenuItem

const retrieveVendorColor = vendorName => {
    switch (vendorName) {
        case 'Tian Tian Hainanese Chicken Rice':
            return '#6AB6E0'
        case 'Bistro Sedap (Halal)':
            return '#7AAA77'
        case 'Kampong Sedap (Halal)':
            return '#5FAE78'
        case 'Wok of Art ':
            return '#F4A300'
        default:
            return '#6c757d'
    }
}
